import _0x476db6 from'./getWindow.js';export default function getComputedStyle(_0x410b38){return _0x476db6(_0x410b38)['getComputedStyle'](_0x410b38);}